import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST,
    fetchEntretiensByCandidatureSuccess,
    fetchEntretiensByCandidatureFail,
    CREATE_ENTRETIEN_REQUEST,
    createEntretienSuccess,
    createEntretienFail,
    UPDATE_ENTRETIEN_REQUEST,
    updateEntretienSuccess,
    updateEntretienFail,
    SEND_INTERVIEW_CALENDAR_REQUEST,
    sendInterviewCalendarSuccess,
    sendInterviewCalendarFail,
    setEntretiensLoading,
} from "../actions/entretiensActions";

import {
    API_BASE_URL,
    getRequest,
    postRequest,
    putRequest,
} from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchEntretiensByCandidatureSaga(action) {
    const { candidatureId } = action.payload;
    const url = `${API_BASE_URL}/api/entretiens/by-candidature/${candidatureId}`;
    const uid = getUid();
    const token = getToken();

    yield put(setEntretiensLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchEntretiensByCandidatureSuccess(candidatureId, resp.data));
    } catch (e) {
        yield put(fetchEntretiensByCandidatureFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setEntretiensLoading(false));
    }
}

export function* createEntretienSaga(action) {
    const url = `${API_BASE_URL}/api/entretiens`;
    const uid = getUid();
    const token = getToken();

    yield put(setEntretiensLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: action.payload,
            uid,
            token,
        });

        yield put(createEntretienSuccess(resp.data));

        if (resp.data?.id) {
            yield put({
                type: SEND_INTERVIEW_CALENDAR_REQUEST,
                payload: {
                    entretienId: resp.data.id,
                    actionType: "SEND_INITIAL_INVITATION",
                    payload: {
                        toParticipantIds: action.payload?.toParticipantIds || [],
                        ccParticipantIds: action.payload?.ccParticipantIds || [],
                    },
                },
            });
        }

        if (action.payload?.candidatureId) {
            yield put({
                type: FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST,
                payload: { candidatureId: action.payload.candidatureId },
            });
        }
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur creation entretien";
        yield put(createEntretienFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setEntretiensLoading(false));
    }
}

export function* updateEntretienSaga(action) {
    const { entretienId, payload, calendarPayload } = action.payload;
    const url = `${API_BASE_URL}/api/entretiens/${entretienId}`;
    const uid = getUid();
    const token = getToken();

    yield put(setEntretiensLoading(true));
    try {
        const resp = yield call(putRequest, {
            url,
            data: payload,
            uid,
            token,
        });

        yield put(updateEntretienSuccess(resp.data));

        yield put({
            type: SEND_INTERVIEW_CALENDAR_REQUEST,
            payload: {
                entretienId,
                actionType: "RESCHEDULE_INTERVIEW",
                payload: calendarPayload || {
                    toParticipantIds: payload?.toParticipantIds || [],
                    ccParticipantIds: payload?.ccParticipantIds || [],
                },
            },
        });

        if (resp.data?.candidatureId) {
            yield put({
                type: FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST,
                payload: { candidatureId: resp.data.candidatureId },
            });
        }
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur mise a jour entretien";
        yield put(updateEntretienFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setEntretiensLoading(false));
    }
}

export function* sendInterviewCalendarSaga(action) {
    const { entretienId, actionType, payload } = action.payload;
    const endpointByAction = {
        SEND_INITIAL_INVITATION: "send",
        RESCHEDULE_INTERVIEW: "reschedule",
        CANCEL_INTERVIEW: "cancel",
    };
    const url = `${API_BASE_URL}/api/entretiens/${entretienId}/calendar/${endpointByAction[actionType] || "send"}`;
    const uid = getUid();
    const token = getToken();

    yield put(setEntretiensLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: payload || {},
            uid,
            token,
        });

        yield put(sendInterviewCalendarSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: "success",
            text: resp.data?.message || "Invitation entretien envoyee",
            timer: 1800,
            showConfirmButton: false,
        });

        if (resp.data?.candidatureId) {
            yield put({
                type: FETCH_ENTRETIENS_BY_CANDIDATURE_REQUEST,
                payload: { candidatureId: resp.data.candidatureId },
            });
        }
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur envoi calendrier entretien";
        yield put(sendInterviewCalendarFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2400,
            showConfirmButton: false,
        });
    } finally {
        yield put(setEntretiensLoading(false));
    }
}
